import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";

export const regimenConfigTableHeaders: TableHeader[] = [
  {
    label: "Regimen Code",
    key: "regimenCode",
    order: 1,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Regimen Name",
    key: "regimenName",
    order: 2,
    width: 30,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Dx Codes",
    key: "dxCodes",
    order: 3,
    width: 40,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "",
    key: "actions",
    order: 4,
    width: 10,
    sortable: false,
    type: TableCellType.EDIT_ICON,
  },
];
